import { render } from "./DependantsView.vue?vue&type=template&id=65b1a708"
import script from "./DependantsView.vue?vue&type=script&lang=js"
export * from "./DependantsView.vue?vue&type=script&lang=js"

import exportComponent from "E:\\doc\\projects\\copAccraCrusade\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__